(function () {
    'use strict';

    var gettext = angular.identity;

    angular
        .module('app.scoring')
        .constant('scoreHistoryPageSize', 20)

        .constant('defaultHandicapCardEmailTitle', gettext('Email Handicap Card'))
        .constant('defaultHandicapCardEmailSubject', gettext('Golf Canada Handicap Card'))
    
        .constant('defaultHandicapCalculationEmailTitle', gettext('Handicap Calculation'))
        .constant('defaultHandicapCalculationEmailSubject', gettext('Handicap Calculation'))

        .constant('scoring_resources', {
            scoreHistoryRequestFailed: gettext('Failed to retrieve score history data.'),
            confirmDeleteScore: gettext('Are you sure you want to delete this score?'),
            deleteScoreFailed: gettext('Unable to delete score.')
        });
})();